import { environment } from "../environments/environment";

//this function returns the time left in token expiry
//this is been used in APP_INITIALIZER to know when we need to refresh the access token
//generally, we refresh the token X seconds before its expiry so this function just calculates the time left (in milliseconds) based on token expiry
//so this function does not return the expiry of token but the time when we need to refresh the token (X seconds before its expiry).
//if the returned value is a negative number, it means that we must refresh it immediately (as the time left in token expiry might have passed)
export function getTokenRefreshTimeOut(tokenExpiry: number): number {
    const expires = new Date(tokenExpiry * 1000);
    const refreshTokenInXSeconds: number = expires.getTime() - Date.now() - (environment.REFRESH_TOKEN_X_SECONDS_BEFORE_EXPIRY * 1000);
    return refreshTokenInXSeconds;
}

export function blobToFile(blob: Blob, fileName: string, lastModified: number): File {
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    var file = new File([blob], fileName, { lastModified: lastModified });
    return file;
}

export function copyToClipboard(textToCopy: string): void {
    // Check if running in browser environment
    if (typeof document === 'undefined') {
        console.warn('copyToClipboard: document is not available (SSR)');
        return;
    }

    // Try modern clipboard API first
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
        navigator.clipboard.writeText(textToCopy).catch(err => {
            console.error('Clipboard write failed:', err);
            // Fallback to legacy method
            legacyCopyToClipboard(textToCopy);
        });
        return;
    }

    // Fallback for older browsers
    legacyCopyToClipboard(textToCopy);
}

function legacyCopyToClipboard(textToCopy: string): void {
    if (typeof document === 'undefined') return;

    const textarea = document.createElement('textarea');
    textarea.value = textToCopy;
    // Make sure the textarea is not visible
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    // Select and copy the text inside the textarea
    textarea.select();
    document.execCommand('copy');
    // Clean up: remove the textarea from the DOM
    document.body.removeChild(textarea);
}